import { Link } from 'react-router-dom';

import styles from './index.module.scss';

import { PATH, URL_MOCHIPAY } from '#/guest-aps/config';

interface PromotionItemProps {
  imageUrl: string;
  backgroundColor: string;
  color: string;
  title: string;
  subTitle: string;
  uri: string | undefined;
  promotionId: string;
  onClick?: () => void;
}

export const PromotionItem = ({
  imageUrl,
  backgroundColor,
  color,
  title,
  subTitle,
  uri,
  onClick,
}: PromotionItemProps) => {
  if (!uri || uri.includes(URL_MOCHIPAY)) {
    return (
      <Link
        onClick={() => {
          onClick?.();
        }}
        to={PATH.PROMOTION}
        style={{
          backgroundImage: `url(${imageUrl})`,
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover',
          backgroundPosition: 'right',
          backgroundColor,
          color,
        }}
        className={styles.item}
      >
        <div>{title}</div>
        <div>{subTitle}</div>
      </Link>
    );
  }
  return (
    <a
      className={styles.item}
      onClick={() => {
        onClick?.();
      }}
      target="_blank"
      rel="noopener noreferrer"
      href={uri}
      style={{
        backgroundImage: `url(${imageUrl})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundColor,
        color,
      }}
    >
      <div>{title}</div>
      <div>{subTitle}</div>
    </a>
  );
};
